import {
   SUPPORTED_LANGUAGE_CODES,
   DEFAULT_LANGUAGE,
} from './languages';

const OVERRIDE_KEY = 'withme_language_override';
const ACTIVE_KEY = 'withme_language';

// Normalize any language tag (e.g. "fr-FR", "FR", "fr") into one of our
// supported 2-letter codes, or null if unsupported.
export const normalize = (lang) => {
   if (!lang || typeof lang !== 'string') return null;
   const two = lang.trim().toLowerCase().slice(0, 2);
   return SUPPORTED_LANGUAGE_CODES.includes(two) ? two : null;
};

const readLocalStorage = (key) => {
   try {
      return typeof window !== 'undefined' ? window.localStorage.getItem(key) : null;
   } catch (e) {
      return null;
   }
};

const writeLocalStorage = (key, value) => {
   try {
      if (typeof window === 'undefined') return;
      if (value == null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
   } catch (e) {
      // quota / disabled storage — non fatal
   }
};

// Resolve active language according to priority:
// 1. user override (localStorage)
// 2. logged-in user's preferred_language
// 3. creator page default_language
// 4. browser navigator.language
// 5. English fallback
export const resolveLanguage = ({ userPreferred, creatorDefault } = {}) => {
   const override = normalize(readLocalStorage(OVERRIDE_KEY));
   if (override) return override;

   const user = normalize(userPreferred);
   if (user) return user;

   const creator = normalize(creatorDefault);
   if (creator) return creator;

   // Fall back to the last active language stored by i18next LanguageDetector
   const active = normalize(readLocalStorage(ACTIVE_KEY));
   if (active) return active;

   const browser =
      typeof navigator !== 'undefined'
         ? normalize(navigator.language || (navigator.languages && navigator.languages[0]))
         : null;
   if (browser) return browser;

   return DEFAULT_LANGUAGE;
};

// Persist an explicit user choice. We write to both override and active keys
// so i18next's LanguageDetector (which reads ACTIVE_KEY) stays consistent.
export const setUserOverride = (lang) => {
   const normalized = normalize(lang);
   if (!normalized) return null;
   writeLocalStorage(OVERRIDE_KEY, normalized);
   writeLocalStorage(ACTIVE_KEY, normalized);
   return normalized;
};

export const clearUserOverride = () => {
   writeLocalStorage(OVERRIDE_KEY, null);
};

export const getUserOverride = () => normalize(readLocalStorage(OVERRIDE_KEY));

export const LANGUAGE_OVERRIDE_STORAGE_KEY = OVERRIDE_KEY;
export const LANGUAGE_ACTIVE_STORAGE_KEY = ACTIVE_KEY;
